export default __webpack_public_path__ + "static/media/close.e826b4e7.svg";